import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bluetooth"
const BluetoothIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.25 2.703C11.25 1.867 12.26 1.449 12.85 2.04L17.936 7.125 13.06 12 17.937 16.875 12.85 21.96C12.26 22.55 11.25 22.132 11.25 21.297V13.81L6.53 18.53 5.47 17.47 10.94 12 5.47 6.53 6.53 5.47 11.25 10.19zM12.75 19.939 15.815 16.875 12.75 13.81zM12.75 10.19 15.815 7.125 12.75 4.061z" />
        </svg>
      }
    </span>
  )
}
export default BluetoothIcon
